import { Stack, Typography } from '@mui/material';
import React from 'react';
import type { IDashboardHeaderProps } from '../interfaces';

export const DashboardHeader = ({ title, subtitle }: IDashboardHeaderProps) => {
  return (
    <Stack spacing={0.5} sx={{ minWidth: 0 }}>
      <Typography
        variant="h2"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
          color: '#18181b',
          letterSpacing: '-0.02em',
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="body2"
          sx={{
            color: '#71717a',
            fontSize: '0.82rem',
            fontWeight: 400,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Stack>
  );
};
